/**
 * Route names for the partner-API webmaster screens. Declared once here so the
 * route definitions and every `router.push({ name })` reference the same
 * constant instead of duplicating string literals.
 */
export const PARTNER_API_ROUTE_NAMES = {
  PARTNER_LIST: "PartnerApi",
  PARTNER_NOTIFICATIONS: "webmasterPartnerNotifications",
  PARTNER_TASKS: "webmasterPartnerTasks",
  TASK_REQUESTS: "webmasterTaskRequests",
  TAXONOMY: "webmasterTaxonomy",
} as const;
